import { ACTIVITY_TYPES } from "Constants/constants";

import type { Activity } from "@packages/client";

export const getActivitiesWithinRange = (
  activities: Activity[],
  from: number,
  to: number
) => {
  const result: Activity[] = [];

  for (let i = 0; i < activities.length; i++) {
    const activity = activities[i];
    const createdAt = new Date(activity.created_at).getTime();
    const completedAt = new Date(activity.completed_at).getTime();

    if (completedAt > from || (createdAt < to && createdAt > from)) {
      result.push(activity);
    }
  }

  return result;
};

/**
 * When a merge action occures, the activity is generated on the source and
 * destination environment. Given an activity and environment name, it checks
 * if this environment was the merge target
 */
const environmentIsMergeTarget = (
  activity: Activity,
  environmentName: string
) => {
  if (activity.type !== ACTIVITY_TYPES.ENVIRONMENT.MERGE) return true;
  return activity.parameters.into === environmentName;
};

export const filterOverlayActivities = (
  activities: Activity[],
  environmentName: string
) => {
  return activities.filter(
    activity =>
      // Evaluation order is important to short circuit failed activity
      // from being tested
      activity.result !== "failure" &&
      environmentIsMergeTarget(activity, environmentName)
  );
};
